import { render, staticRenderFns } from "./KA1.vue?vue&type=template&id=549181be"
import script from "./KA1.vue?vue&type=script&lang=js"
export * from "./KA1.vue?vue&type=script&lang=js"
import style0 from "./KA1.vue?vue&type=style&index=0&id=549181be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports